/* eslint-disable */
import api from '@/utils/backend-api'

export default {
  namespaced: true,
  state: {
    BlockList: '',
    TeacherBlockList:'',
  },
  mutations: {
    setBlockListData (state, {BlockList}) {
      state.BlockList = BlockList
    },
    setTeacherBlockListData (state, {TeacherBlockList}) {
        state.TeacherBlockList = TeacherBlockList
    },
    reset (state) {
        state.TeacherBlockList = ''
        state.BlockList = ''
    }
  },
  actions: {
    getBlockList ({commit}) {
        return new Promise(function (resolve, reject) {
          api.getData('admin/blocked/student')
          .then((response) => {
            var BlockList = response.data
            commit('setBlockListData', {BlockList})
            resolve(BlockList)
          }).catch((error) => {
            reject(error)
          })
        })
      },
      getTeacherBlockList ({commit}) {
        return new Promise(function (resolve, reject) {
          api.getData('admin/blocked/teacher')
          .then((response) => {
            var TeacherBlockList = response.data
            commit('setTeacherBlockListData', {TeacherBlockList})
            resolve(TeacherBlockList)
          }).catch((error) => {
            reject(error)
          })
        })
      },
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/BlockList.js